import { useStoreApi } from '@givebacks/api/store';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { RequestMeta } from 'core/Api';

import { storeKeys } from '../../query-key-factory';

interface CampaignDonationsResponse {
  carts: CampaignDonations;
  meta: RequestMeta;
}
type CampaignDonations = CampaignDonation[];
interface CampaignDonation {
  subtotal: number;
  first_name: string;
  ago: string;
  purchased_at: string;
  created_at: string;
  status: 'purchased' | 'pledged';
}

const useRecentCampaignDonations = ({
  campaignId,
  causeId,
}: {
  campaignId: string;
  causeId?: string;
}) => {
  const StoreApi = useStoreApi();
  const causeQuery = `cause_id=${causeId}`;

  const getCampaignDonations = async () => {
    const { data } = await StoreApi.get<CampaignDonationsResponse>(
      `/store_items/${campaignId}/recent?${causeQuery}`
    );

    return data;
  };
  const queryKey =
    causeId && campaignId
      ? storeKeys.id(causeId).items.campaigns.id(campaignId).recentDonations
      : [];
  return useQuery({
    queryKey: queryKey,
    // queryKey: ['store', 'item', causeId, 'campaigns', campaignId, 'recent_donations'],
    queryFn: getCampaignDonations,
    enabled: !!campaignId && !!causeId,
  });
};
function useListInfiniteUserDonationHistory() {
  const StoreApi = useStoreApi();

  const donationHistory = async ({ pageParam }: { pageParam: { limit: number; offset: number } }) => {
    const { data } = await StoreApi.get(`/carts?limit=${pageParam.limit}&offset=${pageParam.offset}`);

    return data;
  };
  const key = storeKeys.id('user').items.donations.all;
  return useInfiniteQuery({
    queryKey: key,
    queryFn: donationHistory,
    initialPageParam: { limit: 10, offset: 0 },
    getNextPageParam: (lastPageData) => {
      const { meta } = lastPageData;
      const { has_more, limit, offset } = meta;
      if (!has_more) {
        return undefined;
      }
      return { limit, offset: offset + limit };
    },
  });
}

export { useListInfiniteUserDonationHistory, useRecentCampaignDonations };

export type { CampaignDonation };

